export default __webpack_public_path__ + "static/pr-newswire-308-e1ed0b29f7f1777cc01a396f6da852cb.png";